module.exports = __webpack_public_path__ + "static/media/NanumSquareR.4217b4ce.woff";